import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/environmentOcean/pic3_01.png'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"kv\"><div class=\"caption\"><h1>海域監測</h1></div></div><section class=\"sect1\"><div class=\"ctx\"><p>除針對溫排水的溫度進行連續監測外，亦定期對周邊海域進行地形測繪、水文調查 (海流、波浪、潮汐、風速風向、表面漂流)、動植浮游生物與仔稚魚，以及附近定置漁場、漁業經濟調查並追蹤。</p><br><div class=\"gallery gallery1\"><div class=\"imgContainer1-1\"></div><div class=\"imgContainer1-2\"></div></div><div class=\"gallery gallery2\"><div class=\"imgContainer1-3\"></div><div class=\"imgContainer1-4\"></div></div><div class=\"gallery gallery3\"><div class=\"imgContainer1-5\"></div><div class=\"imgContainer1-6\"></div></div><br><p>鄰近和平電廠同屬台泥企業團的和平生態工業港，自 2019 年起獲得歐盟海事組織認證為生態港，2024 年更榮獲環境部國家環境教育獎民營企業組唯一特優的最高榮譽。2021 年和平生態工業港啟動「生態方塊珊瑚移植培育計畫」，以台泥低碳水泥打造生態方塊沉入海中成為人工魚礁，將因自然因素或港區浪潮沖斷的珊瑚斷枝，重新移植到生態方塊上，至 2024 年 7 月共復育 1,001 株，復育存活率達 80%，並展開魚貝類的生態調查。</p></div></section>", 2)
const _hoisted_3 = { class: "sect2" }
const _hoisted_4 = { class: "ctx" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, "生態方塊珊瑚培育成果豐碩", -1)
const _hoisted_6 = { class: "sect3" }
const _hoisted_7 = { class: "ctx" }
const _hoisted_8 = { class: "left" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"tit\">工業港轉型生態港的歷程</div><div class=\"history\"><div class=\"item\"><div class=\"year\">2019</div><div class=\"desp\"><span class=\"tri\"></span>榮獲 <b>歐盟海事組織認證</b> 為生態港</div></div><div class=\"item\"><div class=\"year\">2021</div><div class=\"desp\"><span class=\"tri\"></span>生態港 <b>啟動生態方塊珊瑚移植培育計畫</b></div></div><div class=\"item\"><div class=\"year\">2024</div><div class=\"desp\"><span class=\"tri\"></span>榮獲 <b>環境部國家環境教育獎</b> 最高榮譽</div></div></div><div class=\"tit\">生態方塊珊瑚移植培育計畫</div>", 3)
const _hoisted_12 = {
  class: "coral",
  ref: "coral"
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"graphic\"><img src=\"" + _imports_0 + "\"></div><div class=\"data\"><div class=\"amt\">共 <span class=\"num1\">1001</span> 株</div><div class=\"ratio\">存活率達 <span class=\"num2\">80</span> %</div><div class=\"deadline\">統計至 2024 年 7 月止</div></div>", 2)
const _hoisted_15 = [
  _hoisted_13
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "蓋一個珊瑚的家"),
  /*#__PURE__*/_createElementVNode("p", null, "珊瑚佔海洋面積 0.2%、卻負擔 1/4 魚類的生存，台泥企業團長期關注生物多樣性議題，2021 年於旗下的和平港展開「生態方塊珊瑚移植培育計畫」，在水質媲美澎湖海域的和平生態工業港，為珊瑚蓋一個家。"),
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "100%",
    height: "auto",
    src: "https://www.youtube.com/embed/Aq_AZArAUQI?si=Qw7KdWtVo2TVL0i5",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    referrerpolicy: "strict-origin-when-cross-origin",
    allowfullscreen: ""
  })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_swiper, {
            modules: _ctx.modules,
            "slides-per-view": 1,
            "space-between": 1,
            autoplay: {delay:3000, disableOnInteraction:false},
            speed: 1000,
            loop: true,
            pagination: {clickable:true},
            onSwiper: _ctx.onSwiper,
            onSlideChange: _ctx.onSlideChange,
            class: "swiper"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, { class: "cover cover1" }),
              _createVNode(_component_swiper_slide, { class: "cover cover2" }),
              _createVNode(_component_swiper_slide, { class: "cover cover3" })
            ]),
            _: 1
          }, 8, ["modules", "onSwiper", "onSlideChange"])
        ])
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_12, _hoisted_15, 512),
            _hoisted_16
          ]),
          _hoisted_17,
          _hoisted_18
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}